import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const query = gql`
  mutation StartSuperchargerSmsEnrollment(
    $gameId: Int!
    $phoneNumber: String!
    $smsConsentCopyVersion: String
  ) {
    startSuperchargerSmsEnrollment(
      gameId: $gameId
      phoneNumber: $phoneNumber
      smsConsentCopyVersion: $smsConsentCopyVersion
    )
  }
`;

export function useStartSuperchargerSmsEnrollment() {
  const [mutate, { loading, error }] = useMutation(query);

  const startSuperchargerSmsEnrollment = ({
    gameId,
    phoneNumber,
    smsConsentCopyVersion,
  }) =>
    mutate({
      variables: { gameId, phoneNumber, smsConsentCopyVersion },
    });

  return { startSuperchargerSmsEnrollment, loading, error };
}
